import { memo } from 'react';

import { FileExtensionPreview } from '@air/component-file-extension-preview';

import { RiveContainer } from '~/components/Shared/RiveContainer/RiveContainer';
import { RIVE_THUMBNAIL_CONTAINER, RIVE_THUMBNAIL_ERROR } from '~/constants/testIDs';

export type RiveThumbnailProps = {
  src: string;
  width: number;
  height: number;
  borderRadius?: number;
};

export const RiveThumbnail = memo(({ src, width, height, borderRadius = 4 }: RiveThumbnailProps) => {
  return (
    <RiveContainer
      src={src}
      className="overflow-hidden"
      style={{
        width,
        height,
        borderRadius,
      }}
      data-testid={RIVE_THUMBNAIL_CONTAINER}
      errorFallback={
        <div data-testid={RIVE_THUMBNAIL_ERROR} className="flex size-full">
          <FileExtensionPreview ext="riv" color="gray" size="medium" className="flex-1 justify-center" />
        </div>
      }
      resizeDependencies={[width, height]}
    />
  );
});

RiveThumbnail.displayName = 'RiveThumbnail';
